export enum FormMessageTarget {
    ALL = 'all'
}